/* eslint-disable react/require-default-props */
import { Button, ButtonProps, CircularProgress } from '@mui/material';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { useState } from 'react';

interface IButtonWithSpinnerProps {
  // eslint-disable-next-line react/require-default-props
  buttonProps?: ButtonProps;
  /**
   * When the button should be disabled
   * By default it will be disabled when the promise is running
   */
  // eslint-disable-next-line react/require-default-props
  disabled?: boolean;
  /**
   * A handler for click action, which can return a promise or nothing
   */
  onClick: () => any | Promise<unknown>;
  children?: any;
  buttonText: string;
  styled?: any;
}

export default function CustomDownloadButton({
  buttonProps = {},
  disabled = false,
  onClick,
  children = '',
  buttonText,
  styled
}: IButtonWithSpinnerProps) {
  const [isLoading, setIsLoading] = useState(false);
  return (
    <Button
      variant='outlined'
      size='small'
      disabled={disabled || isLoading}
      style={styled}
      onClick={() => {
        setIsLoading(true);
        onClick()
          .then(() => {
            setIsLoading(false);
          })
          .finally(() => {
            setIsLoading(false);
          });
      }}
    >
      <span style={{ marginRight: '2px' }}> {buttonText}</span>
      {isLoading ? (
        <CircularProgress sx={{ height: '20px', width: '20px' }} size='small' />
      ) : (
        <FileDownloadOutlinedIcon sx={{ height: '20px', width: '20px' }} />
      )}
    </Button>
  );
}
